import {BaseService} from './BaseService';
import {UriBuilder} from './UriBuilder';
import ApplePayPaymentAuthorizationResult = ApplePayJS.ApplePayPaymentAuthorizationResult;

export class ApplePayService extends BaseService {
  private _merchantIdentifier: string = '';
  private readonly inventoryRoot: string;

  constructor(apiUrl: string = '') {
    super();
    this.inventoryRoot = apiUrl;
    this.apiBaseUrl = `${this.inventoryRoot}/v1/order`;
  }

  setMerchantIdentifier(identifier: string): void {
    this._merchantIdentifier = identifier;
  }

  isApplePayAvailable(): boolean {
    // @ts-ignore
    return !!window.ApplePaySession;
  }

  async canMakePayments(): Promise<boolean> {
    return ApplePaySession.canMakePayments();
  }

  createSession(amount: Number, countryCode: string): ApplePaySession {
    const request: ApplePayJS.ApplePayPaymentRequest = {
      countryCode: countryCode,
      currencyCode: 'EUR',
      supportedNetworks: ['visa', 'masterCard'],
      merchantCapabilities: ['supports3DS'],
      total: this.getTotalItem(amount),
    };
    return new ApplePaySession(ApplePayService.API_VERSION, request);
  }

  getTotalItem(amount: Number): ApplePayJS.ApplePayLineItem {
    return {
      label: 'Landesmesse Stuttgart GmbH',
      amount: amount.toString(10),
    };
  }

  async fetchMerchantIdentifier(): Promise<string> {
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('payment/apple-pay/merchant-identifier')
      .build();
    const result = await this.restClient.GET(url);
    if (result.response) {
      return result.response.identifier;
    }
    return this.throwAPIError(result.error);
  }

  async fetchMerchantSession(validationUrl: string): Promise<any> {
    const currentDomain = window.location.host;
    const url = new UriBuilder()
      .fromPath(this.apiBaseUrl)
      .path('payment/apple-pay/merchant-session')
      .build();
    const result = await this.restClient.POST(url, {validationUrl, currentDomain}, {'Content-type': 'application/json'});
    if (result.response) {
      return result.response.session;
    }
    return this.throwAPIError(result.error);
  }

  completeMerchantValidation(session: ApplePaySession, merchantSession): void {
    session.completeMerchantValidation(merchantSession);
  }

  completePaymentMethodSelection(applePaySession: ApplePaySession, e: ApplePayJS.ApplePayPaymentMethodSelectedEvent, amount: Number) {
    const update: ApplePayJS.ApplePayPaymentMethodUpdate = {
      newTotal: this.getTotalItem(amount),
    };
    applePaySession.completePaymentMethodSelection(update);
  }

  completeShippingMethodSelection(applePaySession: ApplePaySession, e: ApplePayJS.ApplePayShippingMethodSelectedEvent, amount: Number) {
    const update: ApplePayJS.ApplePayShippingMethodUpdate = {
      newTotal: this.getTotalItem(amount),
    };
    applePaySession.completeShippingMethodSelection(update);
  }

  completeShippingContactSelection(applePaySession: ApplePaySession, e: ApplePayJS.ApplePayShippingContactSelectedEvent, amount: Number) {
    const update: ApplePayJS.ApplePayShippingContactUpdate = {
      newTotal: this.getTotalItem(amount),
    };
    applePaySession.completeShippingContactSelection(update);
  }

  completePayment(session: ApplePaySession): void {
    const result: ApplePayPaymentAuthorizationResult = {
      errors: undefined,
      status: 0,
    };
    session.completePayment(result);
  }

  beginSession(session: ApplePaySession) {
    session.begin();
  }

  cancelSession(session: ApplePaySession) {
    // session.abort();
  }

  public static API_VERSION = 3;
}
